import { useMutation, useQueryClient } from "react-query";
import { shop } from "@/repositories/shop";
import { AdminReassignShopOwnerRequest } from "@/types/v2";

export const useAdminReassignShopOwnerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: AdminReassignShopOwnerRequest) => shop.adminReassignShopOwner(data),
    {
      // onSettled, not onSuccess: the callable can commit the new owner and
      // then fail demoting the previous one, so the shop must be refetched on
      // error too -- otherwise the dialog keeps showing the old owner.
      //
      // Returned so mutateAsync resolves only AFTER the shop refetch lands.
      // The shop page keys its form on the refetched ownership fields, so the
      // form must see the new data before anyone can click "Update Shop".
      onSettled: (_result, _error, { shopId }) =>
        Promise.all([
          queryClient.invalidateQueries(["shops", shopId]),
          queryClient.invalidateQueries(["paginated-shops"]),
        ]),
    }
  );
};
